
import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const TechnologyPage = lazy(() => import('../pages/technology/page'));
const LoginPage = lazy(() => import('../pages/login/page'));
const SignupSuccessPage = lazy(() => import('../pages/signup-success/page'));
const TermsOfServicePage = lazy(() => import('../pages/terms-of-service/page'));
const PrivacyPolicyPage = lazy(() => import('../pages/privacy-policy/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/about',
    element: <AboutPage />
  },
  {
    path: '/technology',
    element: <TechnologyPage />
  },
  {
    path: '/login',
    element: <LoginPage />
  },
  {
    path: '/signup-success',
    element: <SignupSuccessPage />
  },
  {
    path: '/terms-of-service',
    element: <TermsOfServicePage />
  },
  {
    path: '/privacy-policy',
    element: <PrivacyPolicyPage />
  },
  {
    path: '*',
    element: <NotFoundPage />
  }
];

export default routes;
